'use client';
import ParallaxText from '@components/ParallaxText';
import { Box, Stack } from '@mui/material';

import cn from './style.module.scss';
export default function CommonError(props: any) {
  return (
    <Stack
      component="section"
      className={`${cn.commonErrorWrapper} ${props.className || ''}`}
    >
      <Box className={cn.commonErrorInner}>
        <Box className={cn.commonErrorContent}>
          <Box className={cn.commonErrorContent__icon}>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 127.992 104">
                <path d="M75.976,104A5.968,5.968,0,0,1,70.8,95.06L93.825,54.989a5.968,5.968,0,0,1,10.35,0L127.2,95.06A5.968,5.968,0,0,1,122.025,104ZM97.294,56.982,74.271,97.052A1.967,1.967,0,0,0,75.976,100h46.049a1.967,1.967,0,0,0,1.705-2.948l-23.024-40.07a1.968,1.968,0,0,0-3.413,0Zm1.754,33.989q-.564-.059-1.2-.174-.084-.66-.139-1.264t-.055-1.149q0-.544.055-1.135T97.849,86q.633-.115,1.2-.173a10.791,10.791,0,0,1,2.236,0q.564.058,1.2.173.084.661.139,1.248t.055,1.135q0,.547-.055,1.149t-.139,1.264q-.634.115-1.2.174a11.178,11.178,0,0,1-2.236,0ZM9.841,90A9.842,9.842,0,0,1,0,80.177V25.334a10.437,10.437,0,0,1,10.09-10.251H37.4c1.063,0,1.176-.167,1.346-.421.031-.047.065-.092.1-.136L47.062,4.28A9.825,9.825,0,0,1,55.184,0H92.16A9.842,9.842,0,0,1,102,9.823V48.479a8.94,8.94,0,0,0-4-.418V9.823A5.839,5.839,0,0,0,92.16,4H55.184a5.836,5.836,0,0,0-4.852,2.583c-.031.048-.065.092-.1.136L42.013,16.97A5.143,5.143,0,0,1,37.4,19.084H10.091A6.416,6.416,0,0,0,4,25.334v9.91H23.3a9.828,9.828,0,0,1,8.062,4.191L39.5,47.708a1.9,1.9,0,0,1,.234.289A2.456,2.456,0,0,0,41.5,49.042h53.11A9.953,9.953,0,0,0,90.357,53l-.026.045H41.5A6.429,6.429,0,0,1,36.533,50.4l-8.149-8.279a2.066,2.066,0,0,1-.236-.289A5.828,5.828,0,0,0,23.3,39.244H4V80.177A5.838,5.838,0,0,0,9.841,86H71.394l-2.3,4Zm88.118-6.412L97.71,70.2a10.566,10.566,0,0,1,1.283-.143q.621-.028,1.174-.029t1.157.029a11.182,11.182,0,0,1,1.3.143l-.248,13.387q-.69.144-1.214.2a9.134,9.134,0,0,1-.992.058A12.3,12.3,0,0,1,97.959,83.588ZM86,45.041V30a1.953,1.953,0,0,0-1.9-2H17.9A1.952,1.952,0,0,0,16,30v1.245H12V30a5.955,5.955,0,0,1,5.9-6h66.21A5.954,5.954,0,0,1,90,30V45.041ZM75.9,42.066a2,2,0,1,1,0-4h4.5a2,2,0,0,1,0,4Zm-12.583,0a2,2,0,1,1,0-4h7.549a2,2,0,1,1,0,4Zm-12.583,0a2,2,0,1,1,0-4h7.549a2,2,0,1,1,0,4Zm-9.535,0a2,2,0,0,1,0-4h4.5a2,2,0,0,1,0,4Z" />
              </svg>
            </span>
          </Box>
          <Box className={cn.commonErrorContent__text}>
            <ParallaxText
              variant="h1"
              animationType="zoomIn"
              animationDuration={500}
            >
              Oops
            </ParallaxText>
            <ParallaxText
              variant="h2"
              animationType="zoomIn"
              animationDuration={500}
            >
              Unable to process your request at the moment
            </ParallaxText>
            <ParallaxText
              variant="p"
              animationType="zoomIn"
              animationDuration={500}
            >
              Something went wrong. Please try again.
            </ParallaxText>
          </Box>
        </Box>
      </Box>
    </Stack>
  );
}
